export enum TasksViewTypeEnum {
  calendar = 'calendar',
  cards = 'cards',
}

export enum TaskAssigneePrivacyEnum {
  me = 'me',
  by_me = 'by_me',
  my_team = 'my_team',
}
